import axios from "axios";

// If you set REACT_APP_BACKEND_URL (dev), use it.
// Otherwise default to same-origin proxy base (/vtt-api) in production.
const BACKEND_BASE =
  (process.env.REACT_APP_BACKEND_URL || "/vtt-api").replace(/\/+$/, "");

const api = axios.create({
  baseURL: `${BACKEND_BASE}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dracon_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setAuthToken = (token) => {
  localStorage.setItem("dracon_token", token);
};

export const clearAuthToken = () => {
  localStorage.removeItem("dracon_token");
};

export const registerUser = (payload) => api.post("/auth/register", payload);
export const loginUser = (payload) => api.post("/auth/login", payload);
export const getMe = () => api.get("/auth/me");
export const updateProfile = (payload) => api.put("/profile", payload);

export const getRooms = () => api.get("/rooms");
export const createRoom = (payload) => api.post("/rooms", payload);
export const joinRoom = (roomId) => api.post(`/rooms/${roomId}/join`);
export const getRoomDetail = (roomId) => api.get(`/rooms/${roomId}`);
export const getRoomMap = (roomId) => api.get(`/rooms/${roomId}/map`);
export const updateRoomMap = (roomId, payload) => api.put(`/rooms/${roomId}/map`, payload);

export const getMessages = (roomId) => api.get(`/rooms/${roomId}/messages`);
export const postMessage = (roomId, payload) => api.post(`/rooms/${roomId}/messages`, payload);
export const deleteMessage = (messageId) => api.delete(`/messages/${messageId}`);

export const getDiceRolls = (roomId) => api.get(`/rooms/${roomId}/dice`);
export const rollDice = (roomId, payload) => api.post(`/rooms/${roomId}/dice`, payload);

export const getSheets = (roomId) => api.get(`/rooms/${roomId}/sheets`);
export const createSheet = (roomId, payload) => api.post(`/rooms/${roomId}/sheets`, payload);
export const updateSheet = (sheetId, payload) => api.put(`/sheets/${sheetId}`, payload);
export const deleteSheet = (sheetId) => api.delete(`/sheets/${sheetId}`);

export const getTokens = (roomId) => api.get(`/rooms/${roomId}/tokens`);
export const createToken = (roomId, payload) => api.post(`/rooms/${roomId}/tokens`, payload);
export const updateToken = (tokenId, payload) => api.put(`/tokens/${tokenId}`, payload);
export const deleteToken = (tokenId) => api.delete(`/tokens/${tokenId}`);

export const uploadAsset = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const createInvite = (roomId) => api.post(`/rooms/${roomId}/invites`);
export const getInvite = (code) => api.get(`/invites/${code}`);
export const joinInvite = (code) => api.post(`/invites/${code}/join`);

export const getAdminSettings = () => api.get("/admin/settings");
export const updateAdminSettings = (payload) => api.put("/admin/settings", payload);

export const getDrawings = (roomId) => api.get(`/rooms/${roomId}/drawings`);
export const createDrawing = (roomId, payload) => api.post(`/rooms/${roomId}/drawings`, payload);
